let language = {

    "resourceLibrary:Sort:Created:Newest": "Created: newest first",
    "resourceLibrary:Sort:Created:Oldest": "Created: oldest first",
    "resourceLibrary:Sort:Name:Asc": "Name: A to Z",
    "resourceLibrary:Sort:Name:Desc": "Name: Z to A",
    
  
};

export { language }